function SitesOverview({ id }: any) {
  return <>Overview {id}</>;
}

export default SitesOverview;
